import { render, staticRenderFns } from "./clientFundExchange.vue?vue&type=template&id=d6499228&scoped=true"
import script from "./clientFundExchange.vue?vue&type=script&lang=js"
export * from "./clientFundExchange.vue?vue&type=script&lang=js"
import style0 from "./clientFundExchange.vue?vue&type=style&index=0&id=d6499228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6499228",
  null
  
)

export default component.exports